import { render, staticRenderFns } from "./editVisit.vue?vue&type=template&id=4bfe01a1&scoped=true"
import script from "./editVisit.vue?vue&type=script&lang=js"
export * from "./editVisit.vue?vue&type=script&lang=js"
import style0 from "./editVisit.vue?vue&type=style&index=0&id=4bfe01a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe01a1",
  null
  
)

export default component.exports